module.exports = __webpack_public_path__ + "static/media/dancing-man-drag.7c9570a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dancing-man-drag.svg
// module id = 368
// module chunks = 0